import { TsUtils } from "../../../test-utils";
import { ExternalEscalationType } from "./external-escalation-type.enum";
var ExternalEscalationBuilder = /** @class */ (function () {
    function ExternalEscalationBuilder() {
        this.externalEscalation = {
            externalEscalationType: TsUtils.randomEnumValue(ExternalEscalationType),
            supportedLocales: ["en-US"]
        };
    }
    ExternalEscalationBuilder.prototype.withExternalEscalationType = function (externalEscalationType) {
        this.externalEscalation.externalEscalationType = externalEscalationType;
        return this;
    };
    ExternalEscalationBuilder.prototype.withSupportedLocales = function (supportedLocales) {
        this.externalEscalation.supportedLocales = supportedLocales;
        return this;
    };
    ExternalEscalationBuilder.prototype.build = function () {
        return this.externalEscalation;
    };
    return ExternalEscalationBuilder;
}());
export { ExternalEscalationBuilder };
;
//# sourceMappingURL=external-escalation.builder.js.map